module.exports = __webpack_public_path__ + "static/media/no-results.c984c64c.svg";